import { type ModalProps } from 'antd5';

import { Modal } from 'components/ui';

interface ConfirmationModalProps extends ModalProps {
  message: string | JSX.Element;
  loading?: boolean;
}

export const ConfirmationModal: React.FunctionComponent<ConfirmationModalProps> = ({
  message,
  title = 'Are you sure?',
  okText = 'Yes',
  cancelText = 'No',
  loading = false,
  ...props
}) => (
  <Modal
    title={title}
    okText={okText}
    okButtonProps={{ loading, 'data-testid': 'confirmation-modal-ok-button' }}
    cancelText={cancelText}
    {...props}
  >
    {message}
  </Modal>
);
